/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './styles.css';
import { useHistory, useLocation } from 'react-router-dom';
import { setModalVisible } from '../../../support/store/ModalReducer';
import { measureTypeForm } from '../../../support/services/formatter';

import { Image } from '..';

function Card({ offer = {}, dispatch }) {
  const {
    name,
    value,
    measureType,
    measureQuantity,
    imagesPaths,
  } = offer;

  const imageUrl = imagesPaths[imagesPaths?.length - 1];

  const history = useHistory();
  const location = useLocation();
  const producerName = location.pathname.split('/')[1];

  const handleClick = () => {
    dispatch(setModalVisible({ visible: true, content: offer }));
    history.push(`/${producerName}/offers/${offer.id}`);
  };

  return (
    <button
      type="button"
      className={
        `card 
        ${offer.availableStock || offer.type === 'scheduled_delivery' ? '' : 'sold-out-card'} 
        ${offer.type === 'scheduled_delivery' ? 'scheduled-delivery' : 'prompt-delivery'}`
      }
      onClick={offer.availableStock || offer.type === 'scheduled_delivery' ? handleClick : () => { }}
    >
      <Image src={imageUrl} alt={`Foto do produto ${name}`} />

      <div className="sold-out-indicator">
        Esgotado
      </div>

      <section>
        <div>
          <p className="offer-type">
            {{
              prompt_delivery: 'Pronta entrega',
              scheduled_delivery: 'Encomenda',
            }[offer.type]}
          </p>

          <h2>{name}</h2>

        </div>
        <p className="offer-info">
          {`${Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)} \
          (${measureQuantity} ${measureTypeForm(measureType, measureQuantity)})`}
        </p>

      </section>
    </button>
  );
}

Card.propTypes = {
  horizontal: PropTypes.bool,
  offer: PropTypes.object,
  dispatch: PropTypes.func,
};

export default connect()(Card);
